import { useMemo } from 'react';
import WrapperDataGrid from '@modules/dataGrid/WrapperDataGrid';
import { GridColDef } from '@mui/x-data-grid-pro';
import { generateGlobalColumns, generateEntityColumn, IDataGridConfig, generateBasicColumn } from '@ts/storybook';
import { CElementType, CItemRelation, IConfigComponent } from '@ts/ui-models';

interface ItemRelationsProps {
  configComponent?: IConfigComponent;
  inheritedProps?: any;
}

export const defaultConfigComponent: IConfigComponent = {
  componentId: 'itemRelations',
  aclId: 'tsElementRelation',
  entity: 'itemRelation',
  fetchURL: `/api/itemRelations`,
  crudURL: `/api/itemRelation`,
  mainClass: CItemRelation,
};

const ItemRelations = (props: ItemRelationsProps) => {
  const { configComponent = defaultConfigComponent, inheritedProps } = props;
  const config: IDataGridConfig = {
    columnVisibilityModel: { id: false },
  };

  const getColumns = useMemo((): GridColDef<any>[] => {
    const mixProps = { ...props, configComponent };
    const globalCells = generateGlobalColumns(mixProps);
    return [
      globalCells.id(),
      globalCells.name(),
      generateBasicColumn({ field: 'elementRelationType', headerName: 'Relation type' }, { field: 'elementRelationType.name' }),
      generateEntityColumn(
        { field: 'parentConstraint', headerName: 'Parent item type constraint' },
        { field: 'parentConstraint', mainClass: CElementType },
        { inheritedProps }
      ),
      generateEntityColumn(
        { field: 'childConstraint', headerName: 'Child item type constraint' },
        { field: 'childConstraint', mainClass: CElementType },
        { inheritedProps }
      ),
    ];
  }, [props, configComponent]);

  return (
    <WrapperDataGrid
      configComponent={configComponent}
      dataGridConfig={config}
      columns={getColumns}
      //Extra data
      inheritedProps={inheritedProps}
    />
  );
};

export default ItemRelations;
